export const DATE_PLACEHOLDER = '__.__.____'
